import React from 'react';
import { useTranslation } from "react-i18next";
export const BillingContactSameInfo = ({ register, errors,  }) => {
    const { t } = useTranslation();

    return (
        <div className="row mt-4">
            <div className="col-md-6">
                <div className="form-group">
                    <input {...register("billing.name")} type="text" className="form-control" name="billing.name" id="managerName" placeholder="NameText" />
                    <label htmlFor="managerName" className="float-label">{t('NameText')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        <div>{t(errors.billing?.name?.message)}</div>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <input  {...register("billing.companyName")} type="text" className="form-control" name="billing.companyName" placeholder="OrganizationOrCompanyText" />
                    <label htmlFor="managerCompanyName" className="float-label">{t('OrganizationOrCompanyText')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        <div>{t(errors.billing?.companyName?.message)}</div>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <input {...register("billing.phone")} type="tel" className="form-control" name="billing.phone" placeholder="PhoneNumberText" />
                    <label htmlFor="billing.phone" className="float-label">{t('PhoneNumberText')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        {t(errors.billing?.phone?.message)}
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <input {...register('billing.email')} type="email" className="form-control" name="billing.email" placeholder="EmailText" />
                    <label htmlFor="billing.email" className="float-label">{t('EmailText')} <span className="text-danger"> *</span></label>
                    <div className="helper">{t('emailDescription')}</div>
                    <div className="text-danger">
                        {t(errors.billing?.email?.message)}
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="form-group mb-0">
                    <textarea {...register("billing.address")} placeholder="AddressText" className="form-control" cols="30" rows="1" name="billing.address" ></textarea>
                    <label htmlFor="managerAddress" className="float-label">{t('AddressText')} <span className="text-danger"> *</span></label>
                    <div className="text-danger">
                        {t(errors.billing?.address?.message)}
                    </div>
                </div>
            </div>
        </div>
    )
}